module.exports = __webpack_public_path__ + "media/images/icons/rarr_black-64294a80cfc5fd3ccb381eea621008b8.svg";